<template lang="pug">
a.icon.w-btn.w-btn-icon(
  href='#'
  v-hover-intent:[hoverTimeout]='action'
  v-on='listeners'
  ref='button'
  :class='[ size, classes ]'
)
  slot
    span.dashicons( :class='`dashicons-${icon}`' )
</template>

<script lang="js">
import { Clickable } from '@/mixins'

export const mixin = {
  props: {
    icon: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'lg'
    },
    hoverAction: {
      type: Function,
      default: null
    },
    hoverTimeout: {
      type: Number,
      default: 450
    },
    hover: Boolean,
    noHover: Boolean
  }
}

export default {
  name: 'IconButtonWidget',
  mixins: [ Clickable ],
  components: {},
  props: {
    icon: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'lg'
    },
    hoverAction: {
      type: Function,
      default: null
    },
    hoverTimeout: {
      type: Number,
      default: 200
    },
    hover: Boolean,
    noHover: Boolean
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {
    action() {
      if ( !this.hover ) return
      if ( this.hoverAction ) {
        this.hoverAction()
      } else {
        this.$refs.button.click()
      }
    }
  },
  computed: {}
}
</script>

<style lang="scss">
.w-btn-icon {
  .material-design-icon {
    display: block;
    line-height: 1em;
  }
  &.xs2 {
    .dashicons, .material-design-icon {
      font-size: var(--s-2xs);
      &, svg {
        width: var(--s-2xs);
        height: var(--s-2xs);
      }
    }
  }
  &.xs {
    .dashicons, .material-design-icon {
      font-size: var(--s-xs);
      &, svg {
        width: var(--s-xs);
        height: var(--s-xs);
      }
    }
  }
  &.sm {
    .dashicons, .material-design-icon {
      font-size: var(--s-sm);
      &, svg {
        width: var(--s-sm);
        height: var(--s-sm);
      }
    }
  }
  &.q3 {
    .dashicons, .material-design-icon {
      font-size: var(--s-3q);
      &, svg {
        width: var(--s-3q);
        height: var(--s-3q);
      }
    }
  }
  &.base {
    .dashicons, .material-design-icon {
      font-size: var(--s-base);
      &, svg {
        width: var(--s-base);
        height: var(--s-base);
      }
    }
  }
  &.lg {
    .dashicons, .material-design-icon {
      font-size: var(--s-lg);
      &, svg {
        width: var(--s-lg);
        height: var(--s-lg);
      }
    }
  }
  &.lg2 {
    .dashicons, .material-design-icon {
      font-size: var(--s-2lg);
      &, svg {
        width: var(--s-2lg);
        height: var(--s-2lg);
      }
    }
  }
  &.xl {
    .dashicons, .material-design-icon {
      font-size: var(--s-xl);
      &, svg {
        width: var(--s-xl);
        height: var(--s-xl);
      }
    }
  }
  &.xl2 {
    .dashicons, .material-design-icon {
      font-size: var(--s-2xl);
      &, svg {
        width: var(--s-2xl);
        height: var(--s-2xl);
      }
    }
  }
  &.3xl {
    .dashicons, .material-design-icon {
      font-size: var(--s-3xl);
      &, svg {
        width: var(--s-3xl);
        height: var(--s-3xl);
      }
    }
  }
  &.huge {
    .dashicons, .material-design-icon {
      font-size: var(--s-huge);
      &, svg {
        width: var(--s-huge);
        height: var(--s-huge);
      }
    }
  }
  color: var(--c-fg-btn-icon, var(--c-fg));
  &:hover, &:active, &:focus, &.focus {
    color: var(--c-fg-btn-icon-focus, var(--c-fg));
    &.disabled {
      color: unset;
    }
  }
}
</style>
